"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _config = require("@gymshark/config");

var checkStoreCode = function checkStoreCode(storeCode) {
  if (_config.STAGING_STORES[storeCode]) {
    return _config.STAGING_STORES[storeCode].liveStoreCode;
  }

  return storeCode;
};

var _default = checkStoreCode;
exports["default"] = _default;